<template>
  <div class="review-table-row">

    <!-- COLUMN 1: Source -->
    <div class="col-source">
      <img :src="platformLogo" class="source-logo" />
    </div>

    <!-- COLUMN 2: Attribution -->
    <div class="col-attribution">
      <div class="review-name">{{ name }}</div>
      <div class="review-time">{{ time }}</div>
    </div>

    <!-- COLUMN 3: Rating -->
    <div class="col-rating">
      <span
        v-for="i in safeRating"
        :key="i"
        class="star"
      >
        ★
      </span>
    </div>

    <!-- COLUMN 4: Review -->
    <div class="col-review">
      {{ text }}
    </div>

    <!-- COLUMN 5: AI Reply -->
    <div class="col-action">
      <button
        v-if="status==='active'"
        class="ai-btn"
        @click="$emit('ai-reply')"
      >
        ✨ AI Reply
      </button>
      <button
        v-if="status==='Ai Replied'"
        class="ai-btn"
      >
        AI Replied
      </button>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    name: String,
    text: String,
    time: String,
    rating: [String, Number],
    platform: String,
    status: String
  },

  computed: {
    safeRating() {
      const r = parseInt(this.rating);
      return isNaN(r) ? 0 : r;
    },

    platformLogo() {
      if (!this.platform) return "/images/logo.png";

      const p = this.platform.toLowerCase();

      if (p.includes("google")) return "/images/google.png";
      if (p.includes("facebook")) return "/images/facebook.png";

      return "/images/logo.png";
    }
  }
};
</script>

<style scoped>

/* ===== TABLE ROW ===== */

.review-table-row {
  display: grid;
  grid-template-columns: 80px 220px 140px 1fr 120px;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.2s ease;
}

.review-table-row:hover {
  background: #f8fafc;
}

/* ===== COLUMNS ===== */

.source-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.review-name {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.review-time {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.col-rating {
  color: #fbbf24;
  font-size: 14px;
  display: flex;
  gap: 2px;
}

.col-review {
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
}

/* ===== AI BUTTON ===== */

.col-action {
  text-align: right;
}

.ai-btn {
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #000000, #000000);
  color: white;
  transition: 0.2s ease;
}

.ai-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

</style>